import { useEffect, useRef, useState } from 'react';

const stats = [
  {
    value: '100+',
    label: 'Years Combined Experience',
    icon: 'ri-time-line',
  },
  {
    value: '600+',
    label: 'Rooms Under Management',
    icon: 'ri-hotel-line',
  },
  {
    value: '30 Days',
    label: 'Average Onboarding Time',
    icon: 'ri-calendar-check-line',
  },
  {
    value: '#1 in FL',
    label: 'Performance-Based Mgmt Model',
    icon: 'ri-trophy-line',
  },
];

export default function StatsSection() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-0 bg-amber-500">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-amber-400/40">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`py-12 px-8 text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-3xl text-white/70`}></i>
              </div>
              <div className="text-4xl lg:text-5xl font-light text-white mb-2 tracking-tight">{stat.value}</div>
              <div className="text-xs font-medium text-white/70 uppercase tracking-[0.2em] leading-relaxed">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
